var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlurryGradientBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 300 300",
    width: 300,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur1",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63,
    result: "effect1_foregroundBlur"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#EAA933"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 45,
    fill: "#1CA01F",
    r: 140
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 148,
    fill: "#EAA933",
    r: 140
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 289,
    fill: "#1CA01F",
    r: 140
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 82,
    fill: "#1CA01F",
    r: 140
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 265,
    fill: "#EAA933",
    r: 140
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 183,
    fill: "#1CA01F",
    r: 140
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurryGradientBg);
export default __webpack_public_path__ + "static/media/blurry-gradient-bg.efec396388d86aae3fe0778083e35a4e.svg";
export { ForwardRef as ReactComponent };